import { CategoryIcon, CATEGORY_META } from "@/components/ui/atoms/category-icon";

export interface ExerciseRowProps {
  title: string;
  category: string;
  onClick?: () => void;
}

export function ExerciseRow({ title, category, onClick }: ExerciseRowProps) {
  const cat =
    CATEGORY_META[category as keyof typeof CATEGORY_META] ??
    CATEGORY_META.fondations;

  return (
    <button
      onClick={onClick}
      className="group/ex relative flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-all duration-200 hover:translate-x-1 hover:bg-white/[0.03]"
    >
      <span style={{ color: cat.color }}>
        <CategoryIcon category={category} size={16} />
      </span>

      <span className="min-w-0 flex-1 truncate text-sm text-text-primary">
        {title}
      </span>

      <span className="shrink-0 text-[11px] font-semibold uppercase tracking-[0.15em] text-text-muted/60">
        {cat.label}
      </span>

      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="shrink-0 text-text-muted opacity-0 transition-opacity group-hover/ex:opacity-100"
      >
        <path d="M4 2.5l3.5 3.5-3.5 3.5" />
      </svg>
    </button>
  );
}
